import { Token } from "@0xsquid/squid-types";
import { create } from "zustand";
import { persist } from "zustand/middleware";

export type FavoriteToken = Pick<Token, "address" | "chainId">;

interface FavoriteTokensStore {
  favoriteTokens: FavoriteToken[];
  addFavoriteToken: (token: FavoriteToken) => void;
  removeFavoriteToken: (token: FavoriteToken) => void;
  toggleFavoriteToken: (token: FavoriteToken) => void;
}

export const useFavoriteTokensStore = create(
  persist<FavoriteTokensStore>(
    (set, get) => ({
      favoriteTokens: [],
      addFavoriteToken(token: FavoriteToken) {
        set((state) => ({
          favoriteTokens: [...state.favoriteTokens, token],
        }));
      },
      removeFavoriteToken(token: FavoriteToken) {
        set((state) => ({
          favoriteTokens: state.favoriteTokens.filter(
            (t) => t.chainId !== token.chainId || t.address !== token.address
          ),
        }));
      },
      toggleFavoriteToken(token: FavoriteToken) {
        const isFavorite = get().favoriteTokens.some(
          (t) => t.chainId === token.chainId && t.address === token.address
        );

        if (isFavorite) {
          get().removeFavoriteToken(token);
        } else {
          get().addFavoriteToken(token);
        }
      },
    }),
    {
      name: "squid.favorite.tokens.store",
      version: 1,
    }
  )
);
